//Components
import Collection from './Collection'
import Container from './CollectionContainer'

export default Object.assign(
  Collection,
  {
    Container
  }
)